<template>
  <div id="captcha-checkbox-container" />

  <VPButton
    v-if="showNext"
    class="block min-w-full text-vp-base-100 "
    :label="nextLabel"
    :disabled="lockButtonDisabled"
    variant="solid"
    size="lg"
    @click="emit('next')"
  />
</template>

<script setup lang="ts">
import VPButton from '@/components/form/VPButton.vue';
import { computed } from 'vue';
import { useCheckoutStore } from '@/stores/checkout';
import { LoadingState } from '@/util/LoadingState';

const checkoutStore = useCheckoutStore();

const emit = defineEmits<{
  (e: 'next'): void;
}>();

type Props = {
  showNext: boolean;
  disableNext?: boolean;
  nextLabel?: string;
};

const props = withDefaults(defineProps<Props>(), {
  nextLabel: 'Next',
});

const lockButtonDisabled = computed(
  () => props.disableNext || checkoutStore.shoppingCartLockLoading == LoadingState.LOADING,
);
</script>
